<template>
  <div class="default-header">
    <div class="content h-full flex justify-between items-center">
      <router-link to="/" class="flex items-center">
        <img class="h-16" :src="platform.logo" alt="" />
        <span class="ml-2 text-3xl font-bold">{{ platform.title }}</span>
      </router-link>

      <div class="flex items-center">
        <MySearch />
        <div
          v-if="islogin"
          class="py-2 px-4 flex justify-between items-center text-primary text-base border border-primary"
        >
          <p class="cursor-pointer" @click="handleBackstage">
            <i class="el-icon-user-solid"></i>
            个人中心
            <!-- {{ username }} -->
          </p>
          <i class="w-px h-7 mx-4 inline-block border-l border-primary"></i>
          <el-badge :hidden="unread_msg === 0" :max="9" :value="unread_msg">
            <p class="font-normal cursor-pointer" @click="gotoNotice">消息</p>
          </el-badge>
          <i class="w-px h-7 mx-4 inline-block border-l border-primary"></i>
          <p class="font-normal cursor-pointer" @click="logout">退出</p>
        </div>
        <el-button
          v-else
          class="rounded-none"
          type="primary"
          @click="$router.push(`/auth/login?redirect=${$route.path}`)"
          >登录/注册</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Badge, Input } from "element-ui";
import { mapGetters, mapState } from "vuex";
import MySearch from "./MySearch";

export default {
  name: "DefaultHeader",
  components: {
    [Badge.name]: Badge,
    [Button.name]: Button,
    [Input.name]: Input,
    MySearch,
  },
  computed: {
    ...mapState("app", ["platform"]),
    ...mapGetters("user", ["username", "unread_msg"]),

    islogin: function () {
      return !!this.username;
    },
  },
  methods: {
    handleBackstage() {
      window.location.href = `${location.origin}/u/`;
    },
    gotoNotice() {
      window.location.href = `${location.origin}/u/#/notice`;
    },
    logout() {
      this.$store.dispatch("user/logout");
    },
  },
};
</script>

<style lang="scss" scoped>
.default-header {
  height: 104px;
  background-image: url("@/assets/images/head-bg.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
